import React from "react";
import { Redirect } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useAuth } from "./auth/useAuth.js";
import {
  accessState,
  ACCESS_ALLOWED,
  ACCESS_ANONYMOUS,
  ACCESS_LOADING,
} from "./auth/accessState.js";
import { setObject } from "./helpers/storage";

/**
 * Dead end for someone who signed in successfully but holds no role this app
 * accepts. Ending the identity-provider session instead would sign them out of
 * every other Houm app, so the sign-out is offered as a choice here.
 */
const NoAccess = ({ onLogout }) => (
  <Container className='mt--8 pb-5'>
    <Row className='justify-content-center'>
      <Col lg='5' md='7'>
        <Card className='bg-lighter border-0 mb-0'>
          <CardHeader className='bg-transparent'>
            <div className='text-muted text-center mt-4'>
              <h4>Tu cuenta no tiene acceso a esta plataforma</h4>
            </div>
          </CardHeader>
          <CardBody className='px-lg-5 py-lg-5'>
            <div className='text-center'>
              <p className='text-muted'>
                Pide a un administrador el rol correspondiente, o ingresa con otra cuenta.
              </p>
              <Button className='my-4' color='info' type='button' onClick={onLogout}>
                Cerrar sesion
              </Button>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Container>
);

const PrivateComponent = ({ children }) => {
  const { user, isAuthenticated, isLoading, logout } = useAuth();
  const access = accessState({ isAuthenticated, isLoading, user });

  if (access === ACCESS_LOADING) {
    return <h1>LOADING...</h1>;
  }

  if (access === ACCESS_ANONYMOUS) {
    return <Redirect to='/auth' />;
  }

  if (access === ACCESS_ALLOWED) {
    setObject("userData", {
      name: user.name,
      email: user.email,
    });
    return children;
  }

  return <NoAccess onLogout={() => logout({ returnTo: `${window.location.origin}/auth` })} />;
};

export default PrivateComponent;
